import React, { useState } from "react";
import LeftContactInputSection1 from "./LeftContactSection1/LeftContactInputSection1";
import RightContactCardSection1 from "./RightContactSection1/RightContactCardSection1";

const TopContactSection1 = () => {
  const [data, setdata] = useState({
    name: "",
    email: "",
    phone: "",
    message: "",
  });

  const submitfunc = async () => {
    const postData = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        name: data.name,
        email: data.email,
        phone: data.phone,
        message: data.message,
      }),
    };
    const user_response = await fetch(
      "http://localhost:5000/user/createuser",
      postData
    );
    const user_response_json = await user_response.json();
    console.log(user_response_json, "here is response");
  };
  return (
    <div id="mail">
      <div className="mt-32 lg:flex justify-center w-screen overflow-hidden">
        <div className="left  lg:w-[60%]">
          <form
            action="https://formsubmit.co/kanakjain639@gmail.com"
            method="POST"
          >
            <LeftContactInputSection1
              title="Name"
              fullData={data}
              Data={data.name}
              setData={setdata}
            />
            <LeftContactInputSection1
              title="Email"
              fullData={data}
              Data={data.email}
              setData={setdata}
            />
            <LeftContactInputSection1
              title="Phone"
              fullData={data}
              Data={data.phone}
              setData={setdata}
            />
            <textarea
              className="mx-4 mt-10 w-11/12 border border-x-2 border-y-2 px-9 pt-4 text-2xl"
              title="Mesaage"
              fullData={data}
              Data={data.message}
              setData={setdata}
              id=""
              cols="30"
              rows="10"
              placeholder="Message"
            ></textarea>

            <button
              onClick={() => {
                submitfunc();
              }}
              type="submit"
              className="mx-5 mt-10 w-fit cursor-pointer rounded bg-sky-400 px-8 py-3 text-base font-bold text-white"
            >
              SEND MESSAGE
            </button>
          </form>
        </div>
        <div className="right mx-5 lg:w-3/12 ">
          <RightContactCardSection1
            image="https://cdn-icons-png.flaticon.com/512/126/126509.png"
            title="PHONE NUMBER"
            title1="9997041517"
            title2="9997112688"
          />
          <RightContactCardSection1
            image="https://cdn-icons-png.flaticon.com/512/121/121923.png"
            title="EMAIL ID"
            title1="www.sspublicschool.education"
            title2="38sspublicschool@gmail.com"
          />
          <RightContactCardSection1
            image="https://cdn-icons-png.flaticon.com/512/17/17736.png"
            title="LOCATION"
            title1="38, Indra Colony  Shahganj "
            title2=" Agra  U.P. , India  282010"
          />
        </div>
      </div>
    </div>
  );
};

export default TopContactSection1;
